import PageTitle from '@/components/page-containers/page-title/page-title';
import { AlertTriangle } from 'lucide-react';
interface ErrorLayoutProps {
  title: string;
  description: string;
  logo?: { src: string; alt: string };
  background?: { top?: string; bottom?: string };
  illustration?: string;
  children?: React.ReactNode;
}

export default function ErrorLayout({
  title,
  description,
  logo,
  background,
  illustration,
  children,
}: ErrorLayoutProps) {
  return (
    <>
      <PageTitle title={title} />
      <div className="relative h-screen bg-linear-0 from-secondary to-accent grid place-items-center overflow-hidden">
        {/* background element */}
        {background && (
          <div className="absolute top-0 left-0 size-full flex flex-col justify-between">
            {background.top && (
              <img className="w-full" src={background.top} alt="" />
            )}
            {background.bottom && (
              <img className="w-full" src={background.bottom} alt="" />
            )}
          </div>
        )}

        {/* main content */}
        <div className="relative z-10 flex w-full flex-col items-center justify-center text-center gap-6 md:gap-10 max-w-lg px-6">
          {logo && (
            <img className="w-40 md:w-48" src={logo.src} alt={logo.alt} />
          )}
          {illustration && (
            <img
              className="w-full max-h-80 object-center object-contain"
              src={illustration}
              alt={title}
            />
          )}
          <div className="flex flex-col gap-4 items-center">
            <AlertTriangle className="text-destructive size-18 shrink-0" />
            <div className="flex flex-col gap-2">
              <h2 className="font-heading text-3xl font-bold">{title}</h2>
              <p className="font-light text-lg text-gray-500">{description}</p>
            </div>
          </div>
          {children}
        </div>
      </div>
    </>
  );
}
